<template>
  <div id="app" :style="{'min-width':isMobile?'0':'1200px'}">
    <Header v-if="!isMobile && showTF"></Header>
    <router-view />
    <Footer v-if="!isMobile && showTF"></Footer>
  </div>
</template>

<script>
import Header from "./components/comm/header";
import Footer from "./components/comm/foot";
export default {
  components: { Header, Footer },
  name: 'App',
  watch: {
    $route() {
      this.setMetaFn()
    },
  },
  data() {
    return {
      showTF: false
    }
  },
  methods: {
    setMetaFn() {
      // 获取当前路由的meta信息
      const { title, description, keywords } = this.$route.meta;

      // 更新页面的meta标签 没有就采用首页的
      document.title = title || "印点点自助打印 - 自助打印软件 - 自助打印系统 – 共享打印系统"
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description || "印点点自助打印软件，提供电脑自助打印软件、手机自助打印软件，支持oem贴牌，diy自己专属的自助打印品牌，全国15000+网点都在使用的自助打印系统。");
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords || "印点点自助打印软件,自助打印软件,自助打印系统,自助打印,共享打印软件,共享打印系统");
      }
    }
  },
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.showTF = true;
    }, 200);
  },
  computed: {
    isMobile() {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      switch (this.$route.path) {
        case "/PrintingManagement":
        case "/PrintingManagement/":
        case "/PrinterMeterReading":
        case "/PrinterMeterReading/":
        case "/ProductMap":
        case "/ProductMap/":
          return true
        case "/ShopSelfPrinting":
        case "/ShopSelfPrinting/":
          return mobile
        default: return false
      }
    },
  }
}
</script>

<style>
body,
html {
  width: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'PingFangSC-Light Avenir', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.secd{
  margin: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue